import { MyRegisterActivate } from './myRegisterActivate';

require('./myRegisterActivate.scss');

export const myRegisterActivateComponent = {
  template: require('./myRegisterActivate.html'),
  controllerAs: 'ctrl',
  controller: MyRegisterActivate,
};
